import { useContext } from 'react';
import { LoadingContext } from 'providers/LoadingProvider';

function useGlobalLoading() {
  return useContext(LoadingContext);
}

export default useGlobalLoading;